import { bake_cookie, getCookie } from '../utils/cookie.js'
import { query } from '../utils/query.js'
import Session from '../utils/Session.js'

const infoObj = {}

export function saveInfoToObj() {
	const formSubmited = $('[name="order-payment-form"]').serialize()
	const formItems = formSubmited.split('&')
	let item

	for (let i = 0; i < formItems.length; i++) {
		item = formItems[i].split('=')
		const key = item[0]
		infoObj[key] = item[1]
	}
	return infoObj
}

export function saveInfoToCookie() {
	const customerInfo = saveInfoToObj()
	// save customerInfo 5 minutes
	bake_cookie('customerInfo', customerInfo, 0.0035)
}

export async function saveInfoToSession() {
	const customerInfo = await saveInfoToObj()
	const session = new Session()
	session.set('customerInfo', customerInfo)
}

export function cleanInfoInCookie() {
	bake_cookie('customerInfo', {}, 0.0035)

	const fields = query('.Form__Item input')
	fields.forEach((element, index) => {
		element.value = ''
	})
}

export function autoInput() {
	if (getCookie('customerInfo') !== '') {
		const customerInfoObj = getCookie('customerInfo')
		let jsonResult
		if (typeof customerInfoObj === 'object') {
			jsonResult = customerInfoObj
		} else {
			jsonResult = JSON.parse(customerInfoObj)
			// jsonResult = eval('(' + customerInfoObj + ')')
		}
		delete jsonResult['eid[]']
		delete jsonResult['creditCardNumber']
		delete jsonResult['cvv2Number']
		delete jsonResult['expDateMonth']
		delete jsonResult['expDateYear']
		delete jsonResult['midDelivery']
		// if (jsonResult.address1Billing) {
		for (const prop in jsonResult) {
			if (jsonResult.hasOwnProperty(prop)) {
				const regex = /\+/gi
				let val = jsonResult[prop]
				if (
					prop === 'firstName' ||
					prop === 'firstNameBilling' ||
					prop === 'lastName' ||
					prop === 'lastNameBilling' ||
					prop === 'address1Billing' ||
					prop === 'address1' ||
					prop === 'city' ||
					prop === 'cityBilling'
				) {
					val = val.replace(regex, ' ')
				}

				if (prop === 'orderHelperPaymentMethodId' || prop === 'orderChecksum') {
					// $(`#orderHelperPaymentMethodId_${val}`).prop('checked', true)
				} else {
					$(`[name=${prop}]`).val(val)
				}

				// console.debug(`customerInfoKey: ${prop}`)
				// console.debug(`customerInfoVal: ${val}`)
			}
		}
	}
	// }
}

window.infoObj = infoObj
window.saveInfoToCookie = saveInfoToCookie
window.saveInfoToSession = saveInfoToSession
window.autoInput = autoInput
window.cleanInfoInCookie = cleanInfoInCookie